module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz.7636c15c.jpeg";